module.exports = __webpack_public_path__ + "static/img/rankboardClick-EN-H.51c4786.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/event/Christmas2020/rankboardClick-EN-H.png
// module id = aWuy
// module chunks = 1